'use strict';
define('elements/accordion',['utils/domready'], function(domready) {
  domready(function() {
    /**
     * Get all the accordion elements on the page
     */
    var accordions = document.querySelectorAll('.accordion');
    if (accordions) {
      accordions.forEach(function (accordion) {
        initAccordion(accordion);
      });
    }

  });
});

/**
 * Listen to click events on the accordion title
 * and set the correct openPlate value
 */
function initAccordion(accordion) {
  accordion.titles = accordion.querySelectorAll('.accordion__title');
  if (accordion.titles) {
    accordion.titles.forEach(function (title){
      title.addEventListener('click', function() {
        accordion.openPlate = title.getAttribute('id') === accordion.openPlate
          ? accordion.openPlate = null
          : accordion.openPlate = title.getAttribute('id');
        updateAccordionState(accordion);
      });
    });

    openFirstPanelOnLoad(accordion);
  }
}

/**
 * Update the accordion state accordion to the accordion's openPlace value
 */
function updateAccordionState(accordion) {
  accordion.titles.forEach(function(title) {
    if (title.getAttribute('id') === accordion.openPlate) {
      title.parentNode.classList.add('accordion__plate--open');
    } else {
      title.parentNode.classList.remove('accordion__plate--open');
    }
  });
}

/**
 * Open the first accordion plate
 */
function openFirstPanelOnLoad(accordion) {
  accordion.openPlate = accordion.querySelector('.accordion__title').getAttribute('id');
  updateAccordionState(accordion);
}
;
